import { render, staticRenderFns } from "./page-doubt.vue?vue&type=template&id=0d1a6dbc&scoped=true"
import script from "./page-doubt.vue?vue&type=script&lang=js"
export * from "./page-doubt.vue?vue&type=script&lang=js"
import style0 from "./page-doubt.vue?vue&type=style&index=0&id=0d1a6dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1a6dbc",
  null
  
)

export default component.exports